/**
 * Custom Header — mobile drawer + sticky scroll behaviors
 */
(function () {
  function initCustomHeader(root) {
    if (!root || root.dataset.chInit === 'true') return;
    root.dataset.chInit = 'true';

    var stickyType = root.getAttribute('data-sticky-type') || 'none';
    var sectionId = root.getAttribute('data-section-id') || '';
    var toggle = root.querySelector('[data-custom-header-toggle]');
    var drawer =
      root.querySelector('[data-custom-header-drawer]') ||
      document.querySelector('[data-custom-header-drawer]');
    var overlay =
      root.querySelector('[data-custom-header-overlay]') ||
      document.querySelector('[data-custom-header-overlay]');
    var sectionEl =
      (sectionId && document.getElementById('shopify-section-' + sectionId)) ||
      root.closest('.shopify-section');

    // Keep drawer inside header (recover if an older script moved it to body)
    if (drawer && drawer.parentElement !== root) {
      root.appendChild(drawer);
    }

    // Ensure drawer has links (copy from desktop nav if needed)
    ensureDrawerLinks(root, drawer);

    // Overlay goes to body so it can cover the page
    if (overlay && overlay.parentElement !== document.body) {
      document.body.appendChild(overlay);
    }

    function syncThemeVars(el) {
      if (!el) return;
      ['--ch-bg', '--ch-text', '--ch-muted', '--ch-cta-bg', '--ch-cta-text', '--ch-font-sans', '--ch-font-serif'].forEach(function (prop) {
        var value = getComputedStyle(root).getPropertyValue(prop);
        if (value) el.style.setProperty(prop, value.trim());
      });
    }

    syncThemeVars(drawer);
    syncThemeVars(overlay);

    function setOpen(isOpen) {
      root.classList.toggle('is-open', isOpen);
      if (sectionEl) sectionEl.classList.toggle('custom-header-menu-open', isOpen);
      document.body.classList.toggle('custom-header-drawer-open', isOpen);

      if (toggle) {
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        toggle.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
      }

      if (drawer) {
        drawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');

        // Clear any old inline styles that would kill CSS transitions
        drawer.style.display = '';
        drawer.style.visibility = '';
        drawer.style.opacity = '';
        drawer.style.pointerEvents = '';
        drawer.style.zIndex = '';
        drawer.style.transform = '';

        if (isOpen) {
          // Force a reflow so the closed → open transition always plays
          drawer.classList.remove('is-open');
          void drawer.offsetWidth;
          drawer.classList.add('is-open');
        } else {
          drawer.classList.remove('is-open');
        }
      }

      if (overlay) {
        overlay.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
        overlay.style.display = '';
        overlay.style.position = '';
        overlay.style.inset = '';
        overlay.style.background = '';
        overlay.style.zIndex = '';
        overlay.style.opacity = '';
        overlay.style.visibility = '';

        if (isOpen) {
          overlay.classList.remove('is-open');
          void overlay.offsetWidth;
          overlay.classList.add('is-open');
        } else {
          overlay.classList.remove('is-open');
        }
      }
    }

    if (toggle) {
      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        setOpen(!root.classList.contains('is-open'));
      });
    }

    if (overlay) {
      overlay.addEventListener('click', function () {
        setOpen(false);
      });
    }

    if (drawer) {
      drawer.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
          setOpen(false);
        });
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.classList.contains('is-open')) {
        setOpen(false);
      }
    });

    var desktopMq = window.matchMedia('(min-width: 990px)');
    function onDesktopChange(event) {
      if (event.matches) setOpen(false);
    }
    if (desktopMq.addEventListener) {
      desktopMq.addEventListener('change', onDesktopChange);
    } else if (desktopMq.addListener) {
      desktopMq.addListener(onDesktopChange);
    }

    root.querySelectorAll('[data-custom-header-localization]').forEach(function (select) {
      select.addEventListener('change', function () {
        if (select.form) select.form.submit();
      });
    });

    initSticky(root, sectionEl, stickyType);
  }

  function ensureDrawerLinks(root, drawer) {
    if (!drawer) return;

    var list = drawer.querySelector('.custom-header__drawer-menu');
    var existing = drawer.querySelectorAll('.custom-header__drawer-menu > li').length;
    if (existing > 0) return;

    var desktopItems = root.querySelectorAll('.custom-header__menu > .custom-header__menu-item');
    if (!desktopItems.length) return;

    if (!list) {
      list = document.createElement('ul');
      list.className = 'custom-header__drawer-menu';
      list.setAttribute('role', 'list');
      drawer.insertBefore(list, drawer.firstChild);
    }

    desktopItems.forEach(function (item) {
      var link = item.querySelector(':scope > a.custom-header__menu-link, :scope > a');
      if (!link) return;

      var li = document.createElement('li');
      var a = document.createElement('a');
      a.className = 'custom-header__drawer-link';
      a.href = link.getAttribute('href') || '#';
      a.textContent = link.textContent.trim();
      li.appendChild(a);

      var submenu = item.querySelectorAll('.custom-header__submenu a');
      if (submenu.length) {
        var sub = document.createElement('ul');
        sub.className = 'custom-header__drawer-submenu';
        sub.setAttribute('role', 'list');
        submenu.forEach(function (child) {
          var subLi = document.createElement('li');
          var subA = document.createElement('a');
          subA.className = 'custom-header__drawer-link';
          subA.href = child.getAttribute('href') || '#';
          subA.textContent = child.textContent.trim();
          subLi.appendChild(subA);
          sub.appendChild(subLi);
        });
        li.appendChild(sub);
      }

      list.appendChild(li);
    });
  }

  function initSticky(root, sectionEl, stickyType) {
    if (stickyType === 'none' || !sectionEl) return;

    sectionEl.classList.add('custom-header-section--sticky');
    sectionEl.setAttribute('data-sticky-type', stickyType);

    function setHeaderHeight() {
      document.documentElement.style.setProperty(
        '--custom-header-height',
        sectionEl.offsetHeight + 'px'
      );
    }

    setHeaderHeight();
    window.addEventListener('resize', setHeaderHeight);

    function getScrollTop() {
      var maxTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;
      var node = sectionEl.parentElement;
      while (node && node !== document.documentElement) {
        if (typeof node.scrollTop === 'number' && node.scrollTop > maxTop) {
          maxTop = node.scrollTop;
        }
        node = node.parentElement;
      }
      return maxTop;
    }

    var lastScroll = 0;
    var ticking = false;

    function onScroll() {
      var scrollTop = getScrollTop();
      var headerHeight = sectionEl.offsetHeight || 80;

      if (stickyType === 'always' || stickyType === 'reduce-logo-size') {
        sectionEl.classList.toggle('is-scrolled', scrollTop > 10);
        sectionEl.classList.remove('is-hidden');
      }

      if (stickyType === 'on-scroll-up') {
        if (scrollTop <= 10) {
          sectionEl.classList.remove('is-hidden', 'is-scrolled');
        } else if (scrollTop > lastScroll && scrollTop > headerHeight) {
          sectionEl.classList.add('is-hidden', 'is-scrolled');
        } else if (scrollTop < lastScroll) {
          sectionEl.classList.remove('is-hidden');
          sectionEl.classList.add('is-scrolled');
        }
      }

      lastScroll = scrollTop <= 0 ? 0 : scrollTop;
      ticking = false;
    }

    function requestScrollUpdate() {
      if (!ticking) {
        window.requestAnimationFrame(onScroll);
        ticking = true;
      }
    }

    [window, document, document.documentElement, document.body].forEach(function (target) {
      target.addEventListener('scroll', requestScrollUpdate, { passive: true });
    });

    onScroll();
  }

  function initAll() {
    document.querySelectorAll('[data-custom-header-root]').forEach(initCustomHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    var root = event.target.querySelector('[data-custom-header-root]');
    if (root) {
      root.dataset.chInit = 'false';
      initCustomHeader(root);
    }
  });
})();
